import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import '../../styles/QRConfirmation.css';

export default function QRConfirmation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { qrPayload, visitorName, visitType, expiresAt } = location.state || {};

  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    if (!qrPayload) {
      navigate('/register');
      return;
    }

    const updateCountdown = () => {
      const now = new Date();
      const exp = new Date(expiresAt);
      const diff = exp - now;

      if (diff <= 0) {
        setTimeLeft('Expiré');
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [qrPayload, expiresAt, navigate]);

  if (!qrPayload) return null;

  const visitTypeLabels = {
    etudiant: 'Open Space / Étudiant',
    evenement: 'Événement',
    invite_company: 'Invité (entreprise)',
    invite_person: 'Invité (personne)',
    fournisseur: 'Fournisseur / Livraison',
    reunion: 'Entretien / Réunion',
    commercial: 'Visite commerciale',
  };

  return (
    <div className="qr-confirmation-page">
      <div className="qr-confirmation-container">
        <img src="/images/logo.png" alt="Startup Village" className="qr-logo" />
        <div className="success-icon">✓</div>
        <h1>Votre pass est prêt !</h1>
        <p className="visitor-greeting">Bienvenue, {visitorName}</p>
        <p className="visit-type-label">{visitTypeLabels[visitType] || visitType}</p>

        <div className="qr-code-wrapper">
          <QRCodeSVG
            value={qrPayload}
            size={300}
            level="H"
            includeMargin={true}
          />
        </div>

        <div className="expiry-countdown">
          <span className="countdown-label">Expire dans</span>
          <span className="countdown-timer">{timeLeft}</span>
        </div>

        <div className="qr-instructions">
          <p>Présentez ce code QR au poste de sécurité à l'entrée de Startup Village.</p>
          <p className="email-notice">Un email contenant votre pass a également été envoyé.</p>
        </div>

        <button
          className="btn btn-secondary"
          onClick={() => navigate('/register')}
        >
          Nouvelle inscription
        </button>
      </div>
    </div>
  );
}
